<template>
	<v-row
		no-gutters
		class="inputSelect flex-nowrap"
	>
		<v-col
			cols="4"
			class="flex-grow-1 flex-shrink-0 pa-1"
		>
			<v-btn
				ref="locationBtn"
				class="px-0 pr-sm-4"
				color="white"
				dense
				text
				outlined
				block
				:title="refLocationText"
				:ripple="false"
				:on-click="`fbq('track', 'Search.Select.Province'); _lt('send', 'Search.Select.Province', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
				@click="locationShow"
			>
				<span>{{ refLocationText }}</span>
				<v-icon>mdi-menu-{{ locationActive ? 'up' : 'down' }}</v-icon>
			</v-btn>
			<v-menu
				v-model="locationActive"
				nudge-bottom="1"
				offset-y
				bottom
				right
				:position-x="locationX"
				:position-y="locationY"
				:close-on-content-click="false"
			>
				<v-card>
					<v-stepper v-model="locationStep">
						<v-stepper-items>
							<v-stepper-content
								class="location-select-panel pa-0"
								step="1"
							>
								<v-btn
									text
									tile
									width="100%"
									class="justify-start"
									@click="provinceClicked(null); locationActive = false;"
								>
									ทุกจังหวัด
								</v-btn>
								<v-divider />

								<div
									v-for="province in location"
									:key="province.p"
									:class="(provinceSelected !== province ? 'province-panel' : 'province-panel location-selected')"
									@click="provinceClicked(province)"
								>
									{{ province.n }}
								</div>
							</v-stepper-content>

							<v-stepper-content
								class="location-select-panel pa-0"
								step="2"
							>
								<v-btn
									text
									tile
									width="100%"
									class="justify-start"
									@click="locationStep = 1"
								>
									เลือกจังหวัดอื่น
								</v-btn>
								<v-btn
									text
									tile
									width="100%"
									class="justify-start"
									@click="districtClicked(null)"
								>
									อำเภอ / เขต ทั้งหมด
								</v-btn>
								<v-divider />

								<div
									v-for="district in provinceSelected ? provinceSelected.v : []"
									:key="district.d"
									@click="districtClicked(district)"
								>
									<div
										:class="(districtSelected.indexOf(district) < 0 ? 'district-panel' : 'district-panel location-selected')"
									>
										<v-checkbox
											color="white"
											class="mt-0"
											hide-details
											dense
											:dark="districtSelected.indexOf(district) >= 0"
											:input-value="districtSelected.indexOf(district) >= 0"
											:label="district.n"
										/>
									</div>
									<div
										v-if="districtSelected.indexOf(district) > -1"
										class="sub-district-panel"
									>
										<div
											v-for="subDistrict in district.v"
											:key="subDistrict.s"
											:class="subDistrictSelected.indexOf(subDistrict) < 0 ? 'location-options' : 'location-options location-selected'"
											@click.stop="subDistrictClicked(subDistrict)"
										>
											<input
												type="checkbox"
												:checked="subDistrictSelected.indexOf(subDistrict) >= 0"
											> {{ subDistrict.n }}
										</div>
									</div>
								</div>
							</v-stepper-content>
						</v-stepper-items>
					</v-stepper>
				</v-card>
			</v-menu>
		</v-col>
		<v-col
			cols="4"
			class="flex-grow-1 flex-shrink-0 py-1"
		>
			<v-btn
				ref="useForBtn"
				class="px-0"
				color="white"
				dense
				text
				outlined
				block
				:title="useForText"
				:ripple="false"
				:on-click="`fbq('track', 'Search.Select.TypeProperty'); _lt('send', 'Search.Select.TypeProperty', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
				@click="useForShow"
			>
				<span>{{ useForText }}</span>
				<v-icon>mdi-menu-{{ useForActive ? 'up' : 'down' }}</v-icon>
			</v-btn>
			<v-menu
				v-model="useForActive"
				nudge-bottom="1"
				offset-y
				bottom
				right
				:position-x="useForX"
				:position-y="useForY"
				:close-on-content-click="false"
			>
				<v-card>
					<v-tabs
						v-model="useForTab"
						color="red"
					>
						<v-tab
							href="#ALL"
							@click="useForVal = 'ALL'"
						>
							ทุกประเภท
						</v-tab>
						<v-tab
							href="#REST"
							@click="useForVal = 'REST'"
						>
							ที่อยู่อาศัย
						</v-tab>
						<v-tab
							href="#COMMERCIAL"
							@click="useForVal = 'COMMERCIAL'"
						>
							เชิงพาณิชย์
						</v-tab>
					</v-tabs>

					<v-tabs-items v-model="useForTab">
						<v-tab-item
							value="ALL"
							class="pt-2 black--text"
						>
							<div
								v-for="item in useForRestItems"
								:key="'ALL_' + item.value"
							>
								<v-checkbox
									v-model="useForSelected"
									class="mt-0 px-4 pb-0"
									color="red"
									:label="item.text"
									:value="item.value"
									hide-details
									dense
								/>
							</div>

							<div
								v-for="item in useForCommercialItems"
								:key="'ALL_' + item.value"
							>
								<v-checkbox
									v-model="useForSelected"
									class="mt-0 px-4 pb-0"
									color="red"
									:label="item.text"
									:value="item.value"
									hide-details
									dense
								/>
							</div>
						</v-tab-item>

						<v-tab-item value="REST">
							<div
								v-for="item in useForRestItems"
								:key="item.value"
								:class="item.value === useForVal ? 'bgGrey' : ''"
							>
								<v-btn
									text
									tile
									width="100%"
									class="justify-start"
									@click="useForVal = item.value; useForActive = false;"
								>
									{{ item.text }}
								</v-btn>
							</div>
						</v-tab-item>

						<v-tab-item value="COMMERCIAL">
							<div
								v-for="item in useForCommercialItems"
								:key="item.value"
								:class="item.value === useForVal ? 'bgGrey' : ''"
							>
								<v-btn
									:value="item.value"
									text
									tile
									width="100%"
									class="justify-start"
									@click="useForVal = item.value; useForActive = false;"
								>
									{{ item.text }}
								</v-btn>
							</div>
						</v-tab-item>
					</v-tabs-items>
				</v-card>
			</v-menu>
		</v-col>
		<v-col
			cols="4"
			class="flex-grow-1 flex-shrink-0 pa-1"
		>
			<v-btn
				ref="priceBtn"
				class="px-0 pl-sm-4"
				color="white"
				dense
				text
				outlined
				block
				:title="priceText"
				:ripple="false"
				:on-click="`fbq('track', 'Search.Select.Price'); _lt('send', 'Search.Select.Price', ['345b1f25-4a6f-4421-aac4-893fd36c1be8']);`"
				@click="priceShow"
			>
				<span>{{ priceText }}</span>
				<v-icon>mdi-menu-{{ priceActive ? 'up' : 'down' }}</v-icon>
			</v-btn>
			<v-menu
				v-model="priceActive"
				nudge-bottom="1"
				offset-y
				bottom
				left
				:position-x="priceX"
				:position-y="priceY"
				:close-on-content-click="false"
			>
				<v-card class="price-options">
					<v-row
						no-gutters
						class="flex-nowrap"
					>
						<v-text-field
							v-model="priceMin"
							placeholder="ต่ำสุด"
							dense
							class="input-center"
							@focus="hideMinPrice = false"
						/>
						<div>-</div>
						<v-text-field
							v-model="priceMax"
							placeholder="สูงสุด"
							dense
							class="input-center"
							@focus="hideMinPrice = true"
						/>
					</v-row>

					<div :class="hideMinPrice ? 'd-none' : ''">
						<div>
							<v-btn
								text
								tile
								width="100%"
								class="justify-start"
								@click="priceMin = ''; hideMinPrice = true;"
							>
								ไม่ระบุ
							</v-btn>
						</div>
						<v-divider />
						<div
							v-for="price in priceItems"
							:key="'min-' + price"
							:class="price === priceMin ? 'bgGrey' : ''"
						>
							<v-btn
								text
								tile
								width="100%"
								class="justify-start"
								:disabled="priceMax != '' && price > priceMax"
								@click="priceMin = price; hideMinPrice = true;"
							>
								{{ new Intl.NumberFormat('th-TH').format(price) }} บาท
							</v-btn>
						</div>
					</div>

					<div>
						<div>
							<v-btn
								text
								tile
								width="100%"
								class="justify-end"
								@click="priceMax = ''; priceActive = false;"
							>
								ไม่ระบุ
							</v-btn>
						</div>
						<v-divider />
						<div
							v-for="price in priceItems"
							:key="'max-' + price"
							:class="price === priceMax ? 'bgGrey' : ''"
						>
							<v-btn
								text
								tile
								width="100%"
								class="justify-end"
								:disabled="price < priceMin"
								@click="priceMax = price; priceActive = false;"
							>
								{{ new Intl.NumberFormat('th-TH').format(price) }} บาท
							</v-btn>
						</div>
					</div>
				</v-card>
			</v-menu>
		</v-col>
		<v-col
			class="submitFilter flex-grow-1 flex-shrink-1 d-flex align-center"
		>
			<v-btn
				dense
				texts
				outlineds
				block
				color="white"
				class="px-0 red--text"
				@click="search"
			>
				<!-- <v-icon>mdi-subdirectory-arrow-left</v-icon> -->
				<span style="line-height: 12px; font-size: 12px; font-weight: bold;">ค้นหา</span>
			</v-btn>
		</v-col>
	</v-row>
</template>

<script>

import { mapGetters } from 'vuex'
const configSearch = require('../plugins/config-search')

export default {
	data() {
		return {
			query: {},

			/**
			 * Location AC
			 */
			locationQueryText: '',

			/**
			 * Location options
			 */
			locationX: 0,
			locationY: 0,
			locationActive: false,
			useLocation: false,
			locationStep: 1,
			provinceSelected: null,
			districtSelected: [],
			subDistrictSelected: [],
			locationText: '',

			/**
			 * 'Use for' options
			 */
			useForX: 0,
			useForY: 0,
			useForActive: false,
			useForTab: 'ALL',
			useForVal: 'ALL',
			useForSelected: [
				// ...configSearch.useForRestItems.map(item => item.value),
				// ...configSearch.useForCommercialItems.map(item => item.value)
			],
			useForRestItems: configSearch.useForRestItems,
			useForCommercialItems: configSearch.useForCommercialItems,

			/**
			 * Price options
			 */
			priceX: 0,
			priceY: 0,
			hideMinPrice: false,
			priceActive: false,
			priceMin: '',
			priceMax: '',
			priceItems: configSearch.priceItems,

			// Map local var to GET params
			paramMap: {
				provinceSelected: 'province',
				districtSelected: 'district',
				subDistrictSelected: 'sub_district',
				useForVal: 'market',
				priceMin: 'minprice',
				priceMax: 'maxprice'
			}
		}
	},

	computed: {

		...mapGetters(['isMobile', 'location']),

		refLocationText () {
			let text = 'ทุกจังหวัด'
			if (typeof this.locationQueryText === 'string' && this.provinceSelected) {
				text = this.locationQueryText
			}

			return text
		},

		priceText () {
			let text = ''
			if(this.priceMin === '') {
				text = 'สูงสุด '
				if(this.priceMax === '') {
					text = 'ไม่จำกัดราคา'
				} else {
					text += new Intl.NumberFormat('th-TH').format(this.priceMax) + ' บาท'
				}
			} else {
				text = new Intl.NumberFormat('th-TH').format(this.priceMin)
				if(this.priceMax === '') {
					text = 'เริ่มต้น ' + text + ' บาท'
				} else {
					text += ' - ' + new Intl.NumberFormat('th-TH').format(this.priceMax) + ' บาท'
				}
			}

			return text
		},

		useForText () {
			let text = 'ทุกประเภท'
			if (this.useForVal === 'REST') {
				text = 'ที่อยู่อาศัย'
			} else if (this.useForVal === 'COMMERCIAL') {
				text = 'เชิงพาณิชย์'
			} else if (this.useForVal === 'ALL') {
				if (this.useForSelected.length <= (this.useForRestItems.length + this.useForCommercialItems.length) && this.useForSelected.length > 0) {
					text = `เลือก ${this.useForSelected.length} ประเภท`
				}
			} else {
				for (let item of [...this.useForRestItems, ...this.useForCommercialItems]) {
					if (this.useForVal === item.value) {
						text = item.text
						break
					}
				}
			}

			return text
		},

	},

	watch: {
		locationText (newVal) {
			this.acQuery(newVal)
		},

		/*
		useForSelected (newVal) {
			if (newVal.length === 0) {
				this.useForSelected = [
					...this.useForRestItems.map(item => item.value),
					...this.useForCommercialItems.map(item => item.value)
				]
			}
		},
		*/

		$route (to, from) {
			if (process.client && from.path === to.path) {
				if (window.windowNavigate) {
					window.windowNavigate = false
				}
				this.initCriteria()
			}
		},
	},

	mounted () {
		this.initCriteria()
	},

	methods: {

		initCriteria () {
			// Need to extract (or clone) object (else it will reference to passing var)
			this.query = { ...this.$route.query }

			let key, param, p, d
			for (key in this.paramMap) {
				param = this.paramMap[key]
				if (this.query[param]) {
					if (key === 'provinceSelected') {
						p = this.location.find(p => p.p.toString() === this.query[param].toString())
						this[key] = p
						this.useLocation = true
					} else if (p && key === 'districtSelected') {
						// In case of 1 selected, need to convert to array
						if (typeof this.query[param] !== 'object') {
							this.query[param] = [ this.query[param] ]
						}
						d = p.v.filter(d => this.query[param].findIndex(x => x.toString() === d.d.toString()) > -1)
						this[key] = d
					} else if (p && d && key === 'subDistrictSelected') {
						// In case of 1 selected, need to convert to array
						if (typeof this.query[param] !== 'object') {
							this.query[param] = [ this.query[param] ]
						}
						this[key] = []
						for (let x of d) {
							this[key].push(...x.v.filter(s => this.query[param].findIndex(v => v.toString() === s.s.toString()) >= 0))
						}
					} else if (key === 'locationText') {
						if(!p) {
							// this[key] = this.query[param]
							this.locationQueryText = this.query[param]
						}
					} else {
						this[key] = this.query[param]
					}
				} else if (key === 'txOptionSelected' || key === 'useForVal') {
					this[key] = 'ALL'
				}
			}

			if (d) {
				this.locationStep = 2
			}
			if (p) {
				this.locationTextChange()
			}

			// Check for active 'use-for' tab
			if (this.useForVal === 'REST' || this.useForRestItems.findIndex(u => u.value === this.useForVal) > -1) {
				this.useForTab = 'REST'
			} else if (this.useForVal === 'COMMERCIAL' || this.useForCommercialItems.findIndex(u => u.value === this.useForVal) > -1) {
				this.useForTab = 'COMMERCIAL'
			} else {
				if (this.query['market_selected']) {
					this.useForTab = 'ALL'
					if (typeof this.query['market_selected'] === 'string') {
						this.useForSelected = [ this.query['market_selected'] ]
					} else {
						this.useForSelected = this.query['market_selected']
					}
				} else {
					this.useForSelected = [
						// ...this.useForRestItems.map(item => item.value),
						// ...this.useForCommercialItems.map(item => item.value)
					]
				}
			}
		},

		search () {
			let key, param
			for (key in this.paramMap) {
				param = this.paramMap[key]
				if (this[key]) {
					if (Array.isArray(this[key]) && this[key].length === 0) {
						delete this.query[param]
					} else {
						if (key === 'provinceSelected') {
							this.query[param] = this[key].p
						} else if (key === 'districtSelected') {
							this.query[param] = this[key].map(d => d.d)
						} else if (key === 'subDistrictSelected') {
							this.query[param] = this[key].map(s => s.s)
						} else if (key === 'useForVal') {
							if (this[key] === 'ALL') {
								delete this.query[param]
								if (this.useForSelected.length > 0 && this.useForSelected.length <= (this.useForRestItems.length + this.useForCommercialItems.length)) {
									this.query['market_selected'] = this.useForSelected
								} else {
									delete this.query['market_selected']
								}
							} else  {
								delete this.query['market_selected']
								this.query[param] = this[key]
							}
						} else {
							this.query[param] = this[key]
						}
					}
				} else {
					delete this.query[param]
				}
			}

			// Remove old paging for new search
			delete this.query['page']
			if (this.query['order'] === undefined) {
				delete this.query['order']
			}

			if (this.isMobile) {
				// Set mobile search criteria
				this.$parent.$parent.$parent.$refs.mobileSearchComponent.initCriteria({ ...this.query })
			}

			this.$router.push({
				path: this.$route.path === '/promotion' ? '/promotion' : '/search',
				query: { ...this.query }
			}).catch(() => { })
		},

		locationInputQuery () {
			this.provinceSelected = null
			this.districtSelected = null
			this.subDistrictSelected = null
			this.locationActive = false
			this.useLocation = false
			this.locationStep = 1
		},

		locationShow (event) {
			event.preventDefault()
			let rect = this.$refs.locationBtn.$el.getBoundingClientRect()
			this.locationActive = false
			this.locationX = rect.left
			this.locationY = rect.bottom
			this.$nextTick(() => {
				this.locationActive = true
			})
		},

		provinceClicked (province) {
			this.provinceSelected = province

			if(province === null) {
				this.useLocation = false
				this.locationStep = 1
			} else {
				this.useLocation = true
				this.locationStep = 2
			}

			this.districtSelected = []
			this.subDistrictSelected = []
			this.locationTextChange()
		},

		districtClicked (district) {
			if(district !== null) {
				let index = this.districtSelected.indexOf(district)
				if (index < 0) {
					this.districtSelected.push(district)
				} else {
					this.districtSelected.splice(index, 1)
					for(let sd of district.v) {
						index = this.subDistrictSelected.indexOf(sd)
						if (index > -1) {
							this.subDistrictSelected.splice(index, 1)
						}
					}
				}

				this.useLocation = true
			} else {
				this.subDistrictSelected = []
				this.districtSelected = []
				this.locationActive = false
			}

			this.locationTextChange()
		},

		subDistrictClicked (subDistrict) {
			let index = this.subDistrictSelected.indexOf(subDistrict)
			if(index < 0) {
				this.subDistrictSelected.push(subDistrict)
			} else {
				this.subDistrictSelected.splice(index, 1)
			}
			this.useLocation = true
			this.locationTextChange()
		},

		locationTextChange () {
			this.locationQueryText = (this.provinceSelected ? this.provinceSelected.n : '')
			for(let d of this.districtSelected) {
				this.locationQueryText += ', ' + d.n
			}
			for(let sd of this.subDistrictSelected) {
				this.locationQueryText += ', ' + sd.n
			}
		},

		useForShow (event) {
			event.preventDefault()
			let rect = this.$refs.useForBtn.$el.getBoundingClientRect()
			this.useForActive = false
			this.useForX = rect.left
			this.useForY = rect.bottom
			this.$nextTick(() => {
				this.useForActive = true
			})
		},

		priceShow (event) {
			event.preventDefault()
			let rect = this.$refs.priceBtn.$el.getBoundingClientRect()
			this.priceActive = false
			this.priceX = rect.right
			this.priceY = rect.bottom
			this.$nextTick(() => {
				this.priceActive = true
			})
		},

		clearCiteria () {

			this.query = {}

			/**
			 * Location options
			 */
			this.locationActive = false
			this.useLocation = false
			this.locationStep = 1
			this.provinceSelected = null
			this.districtSelected = []
			this.subDistrictSelected = []
			this.locationText = ''

			/**
			 * 'Use for' options
			 */
			this.useForActive = false
			this.useForTab = 'ALL'
			this.useForVal = 'ALL'
			this.useForSelected = [
				// ...this.useForRestItems.map(item => item.value),
				// ...this.useForCommercialItems.map(item => item.value)
			]

			/**
			 * Price options
			 */
			this.hideMinPrice = false
			this.priceActive = false
			this.priceMin = ''
			this.priceMax = ''
		}
	}
}
</script>

<style lang="scss" scoped>
.v-tabs {
	&::v-deep .v-slide-group__prev--disabled {
		display: none !important;
	}
}
.inputSelect {
	text-align: center;
	max-width: 100%;

	> div {
		padding-bottom: 0;
		padding-top: 0;
	}
	label {
		left: inherit !important;
		right: 20px !important;
	}
	label,
	i {
		color: #fff;
		font-size: 0.9em;
	}
	.v-input__slot {
		background: transparent;
		box-shadow: none!important;
		margin-bottom: 0;
	}
	.v-text-field__details {
		display: none;
	}
	.v-text-field.v-text-field--solo .v-input__control {
		min-height: auto;
	}

	.v-btn::v-deep {
		max-width: 100%;
		border-color: #fff !important;

		&:hover {
			opacity: unset;

			&::before {
				background-color: transparent;
			}
		}

		.v-btn__content {
			width: 100%;
			padding-left: 2px;

			span {
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}
	}
}
.location-select {
	border-top-left-radius: 7px;
	border-bottom-left-radius: 7px;
}
.location-select i {
	transform: rotate(-50deg);
}
.location-select-panel {
	width: 300px;
	max-height: 450px;
	overflow-y: auto;
}
.location-selected {
	background-color: #c20000;
	color: #fff;

	&::v-deep label {
		color: #fff !important;
	}
}
.location-text-field::v-deep {
  input { font-size: 0.9em; }
}
.province-panel, .district-panel {
	padding-left: 10px;
	line-height: 34px;

	&:hover {
		cursor: pointer;

		&:not(.location-selected) {
			background-color: #eee;
		}
	}

	&::v-deep label {
		color: #000;
	}
}
.sub-district-panel {
	margin-left: 19px;

	.location-options:hover {
		cursor: pointer;

		&:not(.location-selected) {
			background-color: #eee;
		}
	}

	input[type="checkbox"] {
		margin-right: 4px;
	}
}
.price-options {
	max-height: 300px;
	overflow-y: auto;
}
.input-center::v-deep input {
	text-align: center !important;
}
.bgGrey {
	background: #eee;
}
.black--text::v-deep label {
	color: black !important;
	font-size: 14px !important;
}

.submitFilter i {
	font-size: 18px !important;
}
</style>
